import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import Logo from 'ui-component/Logo';

// The logo stands in for the "ntab.io" name in both straps, sized to sit on the caption's line.
function LogoLink() {
  return (
    <Link href="https://ntab.io" target="_blank" aria-label="ntab.io" sx={{ display: 'inline-flex', '&:hover': { opacity: 0.8 } }}>
      <Logo height={14} />
    </Link>
  );
}

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', pt: 3, mt: 'auto' }}>
      <Typography variant="caption" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
        &copy; All rights reserved
        <LogoLink />
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link component={RouterLink} to="https://ntab.io/license/" underline="hover" target="_blank" variant="caption" color="text.primary">
          License
        </Link>
        <Link component={RouterLink} to="https://ntab.io/contact/" underline="hover" target="_blank" variant="caption" color="text.primary">
          Contact us
        </Link>
        <Link
          component={RouterLink}
          to="https://ntab.io/store/terms/"
          underline="hover"
          target="_blank"
          variant="caption"
          color="text.primary"
        >
          Terms
        </Link>
        <Link
          component={RouterLink}
          to="https://ntab.io/infrastructure"
          underline="hover"
          target="_blank"
          variant="caption"
          color="text.primary"
        ></Link>
        <Typography variant="caption" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
          <LogoLink />
          pipeline infrastructure
        </Typography>
      </Stack>
    </Stack>
  );
}
